import ChartExpenseByYear from 'src/models/chart-expense-by-year';
import ChartExpenseByCategory from 'src/models/chart-expense-by-category';
import { DashboardYard } from 'src/models/dashboard';
import { endpoints } from 'src/config/endpoints';
import apiBase from './api-base';

export type ChartExpenseByYearResponse = { year: YYYY, data: ChartExpenseByYear[] }[];

export const getChartExpensesByYear = (environmentId: string | number): Promise<ChartExpenseByYearResponse> =>
  new Promise((resolve, reject) => {
    apiBase
      .get(endpoints.dashboard.chartExpenses(environmentId), { params: { groupby: 'year' } })
      .then((response) => {
        resolve(response.data.Data as ChartExpenseByYearResponse);
      });
  });

export const getChartExpensesByCategory = (environmentId: string | number, year?: number | string): Promise<ChartExpenseByCategory[]> =>
  new Promise((resolve, reject) => {
    apiBase
      .get(endpoints.dashboard.chartExpenses(environmentId), { params: { groupby: 'category', year } })
      .then((response) => {
        resolve(response.data.Data as ChartExpenseByCategory[]);
      });
  });

export const getDashboardOverview = async (): Promise<DashboardYard[]> =>
  new Promise((resolve) => {
    apiBase.get(endpoints.dashboard.overview).then((response) => {
      resolve(response.data.Data as DashboardYard[]);
    });
  });

export type GraphsResponse = {
  titles: string[];
  times: string[][];
  temperatures: number[][];
  pressures: number[][];
  ambient_pressures: number[][];
};

export const getGraphs = async (
  measurementId: number | string,
  title?: string
): Promise<GraphsResponse> =>
  new Promise((resolve) => {
    apiBase
      .get(endpoints.dashboard.graphs, { params: { measurement_id: measurementId, title } })
      .then((response) => {
        resolve(response.data.Data as GraphsResponse);
      });
  });

export const saveColor = async (title: string, value: string): Promise<void> =>
  new Promise((resolve) => {
    apiBase
      .post(endpoints.dashboard.saveColor, { title, value })
      .then(() => resolve());
  });
